<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // STYLING
    import 'tailwindcss/tailwind.css';

    // CASSIOPEIA
    import {
        Button,
        Heading,
        InputEmail,
        InputUserName,
        Paragraph,
        SESSION_ORGANIZATION,
        SESSION_USER,
        Small,
        UserForm,
        UserList,
        openModal,
    } from '@smatch/cassiopeia-web-components';

    // TYPES
    import type { User } from 'src/app/types';

    // STORES
    import { SKIP } from '../../store';

    /* INITIALIZE ------------------------------------------------------------------------------ */

    const DEFAULTS: Partial<User> = {
        email: undefined,
        locale: $SESSION_USER?.locale,
        name: {
            first: '',
            last: '',
        },
        organizationKey: $SESSION_ORGANIZATION?._.key,
        role: 'admin',
    };

    let user: Partial<User> = { ...DEFAULTS };

    const ORGANIZATION_KEYS = [ $SESSION_ORGANIZATION!._.key ];

    /* INTERNALS ------------------------------------------------------------------------------- */

    const onSave = (): void => {
        user = { ...DEFAULTS };
    };

    const skipAddUsers = (): void => {
        $SKIP.hasAddedUsers = true;
        openModal('#onboarding');
    };

</script>

<div class = 's8-wrap'>

    <Heading size = 'md'>Invite Your Colleagues to smatch</Heading>

    <UserList parameters = { { organizationKeys: ORGANIZATION_KEYS } } let:users>
        <ul class = 's8-users'>
            {#each users as user}
                <li>
                    <!-- TODO: Fix slot types -->
                    <!-- eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -->
                    { user.name.first } { user.name.last }<br />
                    <Small>{ user.email }</Small>
                </li>
            {/each}
        </ul>
    </UserList>

    <UserForm action = 'create' on:save = { onSave } { user }>

        <div class = 's8-form'>

            <Paragraph>
                New users are automatically added to your organization.
                They will receive an email from smatch and can log in immediately.
            </Paragraph>

            <InputUserName bind:value = { user.name } isRequired = { true } />
            <InputEmail bind:value = { user.email } placeholder = 'Email' isRequired = { true } />

            <div class = 's8-footer'>

                <Button
                    type = 'button'
                    label = 'Cancel'
                    color = 'neutral'
                    css = 'w-full'
                    on:click = { skipAddUsers }
                />

                <Button
                    type = 'submit'
                    label = 'Save'
                    css = 'w-full'
                />

            </div>

        </div>

    </UserForm>

</div>

<style lang='postcss'>

    div.s8-wrap {

        ul.s8-users {
            margin: 20px 0px 30px 0px;

            li:not(:last-child) {
                padding-bottom: 10px;
                border-bottom: 1px solid rgba(39, 39, 17, 0.06);
                margin-bottom: 10px;
            }
        }

        div.s8-form {
            padding: 20px;
            border-radius: 10px;
            background-color: rgba(39, 39, 17, 0.03);

            :global(.s8-form-row) {
                padding-bottom: 0px !important;
                margin-bottom: 0px !important;
            }
        }

        div.s8-footer {
            display: flex;
            column-gap: 10px;
            flex-grow: 1;
            align-items: flex-end;
            margin-top: 20px;
        }

        :global(form#s8-form-create-address),
        :global(form#s8-form-update-address) {
            flex-grow: 1;
            display: flex;
        }

        :global(form#s8-form-create-address div.s8-form-body),
        :global(form#s8-form-update-address div.s8-form-body) {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
        }
    }

</style>